export default __webpack_public_path__ + "static/media/proximamente.246116fa.gif";